import { render } from "./CustomerArView.vue?vue&type=template&id=34672a2e&scoped=true"
import script from "./CustomerArView.vue?vue&type=script&lang=js"
export * from "./CustomerArView.vue?vue&type=script&lang=js"

import "./CustomerArView.vue?vue&type=style&index=0&id=34672a2e&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34672a2e"]])

export default __exports__